import { render } from "./OPINION_UPDATED_AND_MADE_PUBLIC_BY_ORG.vue?vue&type=template&id=7b762832"
import script from "./OPINION_UPDATED_AND_MADE_PUBLIC_BY_ORG.vue?vue&type=script&lang=js"
export * from "./OPINION_UPDATED_AND_MADE_PUBLIC_BY_ORG.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__